import React from 'react';
import LoveAnimationGallery from './LoveAnimationGallery';
import LoveAnimation from './LoveAnimation';
import LoveAnimation3 from './LoveAnimation3';
import LoveAnimation1 from './LoveAnimation1';
import LoveAnimation2 from './LoveAnimation2';
import LoveAnimation4 from './LoveAnimation4';
import LoveAnimation5 from './LoveAnimation5';

const ImageGallery: React.FC = () => {
    const images = [
        {
            id: 1,
            title: "19/07/2024",
            description: "Lần đầu gặp em",
            image: "/album/0.jpg"
        },
        {
            id: 2,
            title: "11/05/2025",
            description: "Sinh nhật em",
            image: "/album/1.jpg"
        },
        {
            id: 3,
            title: "Cùng đi Hội An",
            description: "Những trải nghiệm tuyệt vời",
            image: "/album/2.jpg"
        },
        {
            id: 4,
            title: "Vincom",
            description: "Chia sẻ niềm vui cùng nhau",
            image: "/album/3.jpg"
        },
        {
            id: 5,
            title: "Vincom",
            description: "Những khoảnh khắc quý giá",
            image: "/album/4.jpg"
        },
        {
            id: 6,
            title: "Album ảnh hồi bé của em",
            description: "Những khoảnh khắc ngọt ngào",
            image: "/album/5.jpg"
        },
        {
            id: 7,
            title: "Kỷ niệm đẹp",
            description: "Những trải nghiệm tuyệt vời",
            image: "/album/6.jpg"
        },
        {
            id: 8,
            title: "Jia Coffee",
            description: "Chia sẻ niềm vui cùng nhau",
            image: "/album/7.jpg"
        },
        {
            id: 9,
            title: "Những kỷ niệm đẹp",
            description: "Những khoảnh khắc đáng nhớ",
            image: "/album/8.jpg"
        },
        {
            id: 10,
            title: "Thời gian bên nhau",
            description: "Những trải nghiệm ngọt ngào",
            image: "/album/9.jpg"
        },
        {
            id: 11,
            title: "Kỷ niệm tuyệt vời",
            description: "Những khoảnh khắc quý giá",
            image: "/album/10.jpg"
        },
        {
            id: 12,
            title: "Khoảnh khắc đẹp",
            description: "Chia sẻ niềm vui cùng nhau",
            image: "/album/11.jpg"
        },
        {
            id: 13,
            title: "Những kỷ niệm đáng nhớ",
            description: "Những trải nghiệm tuyệt vời",
            image: "/album/12.jpg"
        },
        {
            id: 14,
            title: "Thời gian yêu nhau",
            description: "Những khoảnh khắc ngọt ngào",
            image: "/album/13.jpg"
        },
        {
            id: 15,
            title: "Kỷ niệm quý giá",
            description: "Những khoảnh khắc đẹp",
            image: "/album/14.jpg"
        },
        {
            id: 16,
            title: "Khoảnh khắc đáng nhớ",
            description: "Những trải nghiệm tuyệt vời",
            image: "/album/15.jpg"
        },
        {
            id: 17,
            title: "Thời gian bên nhau",
            description: "Chia sẻ niềm vui cùng nhau",
            image: "/album/16.jpg"
        },
        {
            id: 18,
            title: "Kỷ niệm đẹp",
            description: "Những khoảnh khắc quý giá",
            image: "/album/17.jpg"
        },
        {
            id: 19,
            title: "Những khoảnh khắc đẹp",
            description: "Những trải nghiệm ngọt ngào",
            image: "/album/19.jpg"
        },
        {
            id: 20,
            title: "Kỷ niệm tuyệt vời",
            description: "Chia sẻ niềm vui cùng nhau",
            image: "/album/20.jpg"
        },
        {
            id: 21,
            title: "Thời gian yêu nhau",
            description: "Những khoảnh khắc đáng nhớ",
            image: "/album/21.jpg"
        },
        {
            id: 22,
            title: "Khoảnh khắc quý giá",
            description: "Những trải nghiệm tuyệt vời",
            image: "/album/22.jpg"
        },
        {
            id: 23,
            title: "Những kỷ niệm đẹp",
            description: "Chia sẻ niềm vui cùng nhau",
            image: "/album/23.jpg"
        },
        {
            id: 24,
            title: "Kỷ niệm đáng nhớ",
            description: "Những khoảnh khắc ngọt ngào",
            image: "/album/24.jpg"
        },
        {
            id: 25,
            title: "Thời gian bên nhau",
            description: "Những khoảnh khắc quý giá",
            image: "/album/25.jpg"
        },
        {
            id: 26,
            title: "Khoảnh khắc đẹp",
            description: "Những trải nghiệm tuyệt vời",
            image: "/album/26.jpg"
        },
        {
            id: 27,
            title: "Những kỷ niệm đẹp",
            description: "Chia sẻ niềm vui cùng nhau",
            image: "/album/27.jpg"
        },
        {
            id: 28,
            title: "Kỷ niệm tuyệt vời",
            description: "Những khoảnh khắc đáng nhớ",
            image: "/album/28.jpg"
        },
        {
            id: 29,
            title: "Thời gian yêu nhau",
            description: "Những trải nghiệm ngọt ngào",
            image: "/album/29.jpg"
        },
        {
            id: 30,
            title: "Khoảnh khắc quý giá",
            description: "Những khoảnh khắc đẹp",
            image: "/album/30.jpg"
        },
        {
            id: 31,
            title: "Những kỷ niệm đẹp",
            description: "Chia sẻ niềm vui cùng nhau",
            image: "/album/31.jpg"
        },
        {
            id: 32,
            title: "Kỷ niệm đáng nhớ",
            description: "Những khoảnh khắc quý giá",
            image: "/album/32.jpg"
        },
        {
            id: 33,
            title: "Thời gian bên nhau",
            description: "Những trải nghiệm tuyệt vời",
            image: "/album/33.jpg"
        },
        {
            id: 34,
            title: "Khoảnh khắc đẹp",
            description: "Những khoảnh khắc ngọt ngào",
            image: "/album/34.jpg"
        },
        {
            id: 35,
            title: "Những kỷ niệm đẹp",
            description: "Chia sẻ niềm vui cùng nhau",
            image: "/album/35.jpg"
        },
        {
            id: 36,
            title: "Kỷ niệm tuyệt vời",
            description: "Những khoảnh khắc đáng nhớ",
            image: "/album/36.jpg"
        },
        {
            id: 37,
            title: "Thời gian yêu nhau",
            description: "Những trải nghiệm ngọt ngào",
            image: "/album/37.jpg"
        },
        {
            id: 38,
            title: "Khoảnh khắc quý giá",
            description: "Những khoảnh khắc đẹp",
            image: "/album/38.jpg"
        },
        {
            id: 39,
            title: "Những kỷ niệm đẹp",
            description: "Chia sẻ niềm vui cùng nhau",
            image: "/album/39.jpg"
        },
        {
            id: 40,
            title: "Kỷ niệm đáng nhớ",
            description: "Những khoảnh khắc quý giá",
            image: "/album/40.jpg"
        },
    ];

    return (
        <section className="py-16 bg-gradient-to-b from-white to-pink-custom-50">
            <div className="container mx-auto px-4">
                <div className="text-center mb-12">
                    <h2 className="text-4xl font-bold text-pink-custom-800 mb-4">
                        Khám phá những điều tuyệt vời
                    </h2>
                    <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                        Chia sẻ những khoảnh khắc đẹp và những món ăn ngon cùng nhau
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {images.map((item, index) => (
                        <React.Fragment key={item.id}>
                            <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 group">
                                <div className="relative overflow-hidden">
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        className="w-full h-96 object-cover object-center group-hover:scale-105 transition-transform duration-300"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                                </div>
                                <div className="p-6">
                                    <h3 className="text-xl font-semibold text-pink-custom-800 mb-2">
                                        {item.title}
                                    </h3>
                                    <p className="text-gray-600">
                                        {item.description}
                                    </p>
                                    {/* <button className="mt-4 px-6 py-2 bg-pink-custom-500 text-white rounded-lg hover:bg-pink-custom-600 transition-colors duration-200">
                                        Xem thêm
                                    </button> */}
                                </div>
                            </div>

                            {/* Chèn LoveAnimation sau mỗi 6 ảnh */}
                            {(index + 1) % 6 === 0 && (
                                <div className="col-span-full mt-16">
                                    <div className="text-center mb-8">
                                        <h3 className="text-3xl font-bold text-pink-600 mb-4">
                                            💕 Tình yêu của chúng ta 💕
                                        </h3>
                                        <p className="text-gray-600 text-lg">
                                            Những trái tim đang nhảy múa vì tình yêu
                                        </p>
                                    </div>
                                    {(() => {
                                        const animationIndex = Math.floor((index + 1) / 6) - 1;
                                        const animations = [
                                            <LoveAnimation key="love" />,
                                            <LoveAnimation1 key="love1" />,
                                            <LoveAnimation2 key="love2" />,
                                            <LoveAnimation3 key="love3" />,
                                            <LoveAnimation4 key="love4" />
                                        ];
                                        return animations[animationIndex % animations.length];
                                    })()}
                                </div>
                            )}
                        </React.Fragment>
                    ))}
                </div>

                {/* <div className="text-center mt-12">
                    <button className="px-8 py-3 bg-pink-custom-600 text-white rounded-lg hover:bg-pink-custom-700 transition-colors duration-200 text-lg font-medium">
                        Xem tất cả
                    </button>
                </div> */}
            </div>

            {/* Love Animation Gallery */}
            {/* <LoveAnimation1 />
            <LoveAnimation2 />
            <LoveAnimation3 />
            <LoveAnimation4 /> */}
            {/* <LoveAnimation5 /> */}
        </section>
    );
};

export default ImageGallery; 